"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LauncherLogo = exports.TEST_ID_LAUNCHER_LOGO = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var JagexLogo_1 = require("../../atoms/JagexLogo/JagexLogo");
var launcher_svg_1 = __importDefault(require("./launcher.svg"));
exports.TEST_ID_LAUNCHER_LOGO = "launcher-logo";
function LauncherLogo(_a) {
    var title = _a.title, alt = _a.alt, _b = _a.iconColor, iconColor = _b === void 0 ? JagexLogo_1.DEFAULT_JAGEX_ICON_COLOR : _b, _c = _a.nameColor, nameColor = _c === void 0 ? JagexLogo_1.DEFAULT_JAGEX_NAME_COLOR : _c, csx = _a.csx;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: __assign({ alignItems: "center", justifyContent: "center" }, csx), "data-testid": exports.TEST_ID_LAUNCHER_LOGO },
        theme_ui_1.jsx(__1.JagexLogo, { title: title, iconColor: iconColor, nameColor: nameColor }),
        theme_ui_1.jsx(__1.Image, { title: title, alt: alt, src: launcher_svg_1.default, csx: { ml: 2 } })));
}
exports.LauncherLogo = LauncherLogo;
LauncherLogo.defaultProps = {
    iconColor: JagexLogo_1.DEFAULT_JAGEX_ICON_COLOR,
    nameColor: JagexLogo_1.DEFAULT_JAGEX_NAME_COLOR
};
